import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

interface ScanExample {
  image: string;
  label: string;
}

export const useScanInfo = (fontClass = 'font-ib') => {
  const t = useTranslations('lens-process');

  const incorrectExamples: ScanExample[] = [
    {
      image: '/lens-process/missing-information.png',
      label: t('scanPrescription.missingInformation'),
    },
    {
      image: '/lens-process/unclear.png',
      label: t('scanPrescription.unclearOrBlurryText'),
    },
    {
      image: '/lens-process/insufficient-lighting.png',
      label: t('scanPrescription.insufficientLighting'),
    },
  ];

  const prescriptionInfo: ReactNode[] = [
    t.rich('scanPrescription.requiredInformation', {
      b: (chunks) => <span className={fontClass}>{chunks}</span>,
    }),
    t.rich('scanPrescription.pleaseVerify', {
      b: (chunks) => <span className={fontClass}>{chunks}</span>,
    }),
    t.rich('scanPrescription.note', {
      b: (chunks) => <span className={fontClass}>{chunks}</span>,
    }),
  ];

  return {
    incorrectExamples,
    prescriptionInfo,
  };
};
